import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { Info } from "@mui/icons-material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { customGetAPI } from "services/utils/CustomAPI";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { Loader } from "components/Loader";
import moment from "moment";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import { useSelector } from "react-redux";
import { CustomAutoComplete } from "components/CustomComponents";
import { formKeyText } from "services/constants/Styles";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { showToast } from "services/utils/Status";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";
import { tooltipStyleProps } from "services/constants/Styles";

export const Monthly = ({
  loading,
  isLoading,
  monthlyShiftList,
  listOfDate,
  filterChanges,
  setFilterChanges,
  shiftGrpError,
  setGrpNameError,
  openDialog,
  setOpenDialog,
  updateMonthlyShift,
  departmentIdValue,
  departmentNames,
  masterDataForSearch,
}) => {
  const [page, setLeavePage] = useState(0);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };
  const [userShiftsDet, setUserShiftsDet] = useState([]);
  const [curShiftDetail, setCurShiftDetail] = useState([]);
  const [shiftName, setShiftName] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [shiftData, setShiftData] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const [getSftDate, setgetSftDate] = useState("");
  const [shiftBased, setShiftBased] = useState(
    departmentNames === "All" ? "All Department" : "Current Department"
  );
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [disable, setDisable] = useState(true);
  const [getDepartmentId, setGetDepartmentId] = useState("");
  const handleChangeRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };
  const containerRef = useRef(null);

  useEffect(() => {
    setShiftBased(
      departmentNames === "All" ? "All Department" : "Current Department"
    );
  }, [departmentNames]);

  const sortedMonthlyShiftList = monthlyShiftList?.sort((a, b) => {
    const assignNameA = a.user_name || "";
    const assignNameB = b.user_name || "";
    return assignNameA.localeCompare(assignNameB, undefined, {
      numeric: true,
    });
  });

  const dateStr = getSftDate;
  const [day, month, year] = dateStr.split("-");
  const formattedDate = `${year}-${month}-${day}`;
  const [calculateInnerWidth, setCalculateInnerWidth] = useState(
    window.innerWidth < 1400
  );
  const [latestPayDate, setLatestPayDate] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [state, setState] = useState(() => {
    const formattedLatestPayDate = moment(latestPayDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    const index = listOfDate.indexOf(formattedLatestPayDate);

    const startDate =
      index !== -1 && index + 1 < listOfDate.length
        ? moment(listOfDate[index + 1])
        : moment(listOfDate[0]);

    const endDate = moment(listOfDate[listOfDate.length - 1]);

    return {
      start: startDate,
      end: endDate,
    };
  });

  useEffect(() => {
    const formattedLatestPayDate = moment(latestPayDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    const index = listOfDate.indexOf(formattedLatestPayDate);

    const startDate =
      index !== -1 && index + 1 < listOfDate.length
        ? moment(listOfDate[index + 1])
        : moment(listOfDate[0]);

    const endDate = moment(listOfDate[listOfDate.length - 1]);
    setState({
      start: startDate,
      end: endDate,
    });
    if (index !== -1 && index + 1 < listOfDate.length) {
      setSelectedDates(listOfDate.slice(index + 1));
    } else {
      setSelectedDates(listOfDate);
    }
  }, [latestPayDate, listOfDate]);

  useEffect(() => {
    const handleResize = () => {
      setCalculateInnerWidth(window.innerWidth < 1400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (filterChanges) {
      setFilterChanges(false);
      setLeavePage(0);
    }
  }, [filterChanges, setFilterChanges]);

  const { start, end } = state;
  const handleCallback = (start, end) => {
    setState({ start, end });

    const dates = [];
    const currentDate = moment(start);

    while (currentDate.isSameOrBefore(end, "day")) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(1, "day");
    }
    setSelectedDates(dates);
    setShiftName("");
    setDisable(false);
  };

  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");

  const handleChangeShift = (event, data) => {
    if (data) {
      setShiftName(data?.label);
      setShiftId(data?.shift_id);
      setDisable(false);
    } else {
      setShiftName("");
      setShiftId("");
    }
  };

  const hasDatesBeforeLatestPayDate = selectedDates.some((date) =>
    moment(date).isBefore(moment(latestPayDate, "DD-MM-YYYY"), "day")
  );

  const updateIndividualShift = async () => {
    isLoading(true);
    const shift_assignments = selectedDates.map((date) => ({
      shift_id: shiftId ?? curShiftDetail?.shift_id,
      date: date,
      is_week_off: shiftName === "Weekoff",
      unassigned: curShiftDetail?.shift_name === "Unassigned",
    }));
    if (shiftName !== "" && !hasDatesBeforeLatestPayDate) {
      updateMonthlyShift(userShiftsDet?.user_id, shift_assignments);
      setShiftBased(
        departmentNames === "All" ? "All Department" : "Current Department"
      );
      setOpenDialog(false);
      const startDate = moment(listOfDate[0]);
      const endDate = moment(listOfDate[listOfDate.length - 1]);
      setState({ start: startDate, end: endDate });
      setSelectedDates(listOfDate);
    } else if (shiftName === "") {
      isLoading(false);
      setGrpNameError(true);
    } else {
      isLoading(false);
      showToast("error", "Selected detes must after previous payrun date");
    }
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      const url =
        shiftBased === "Current Department"
          ? `${domain}deparment-shift-filter/?department_id=${
              shiftBased === "Current Department"
                ? getDepartmentId
                : departmentIdValue
            }&date=${formattedDate}`
          : `${domain}all/shift-filter/`;
      const res = await customGetAPI(url);
      if (res.ok) {
        setShiftData(res?.responseDetails);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
      setTriggerApi(false);
    }
  }, [
    departmentIdValue,
    domain,
    formattedDate,
    getDepartmentId,
    shiftBased,
    triggerApi,
  ]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const selectShiftBased = (event) => {
    setShiftBased(event.target.value);
    setTriggerApi(true);
    setGrpNameError(false);
    setDisable(false);
  };

  return (
    <React.Fragment>
      {loading ? (
        <Mui.Box>
          <Loader info="Loading..." />
        </Mui.Box>
      ) : (
        <>
          <Mui.Grid container>
            <Mui.TableContainer
              ref={containerRef}
              component={Mui.Paper}
              sx={{
                mt: 2,
                width: "100%",
                border: 1,
                borderRadius: 5,
                borderColor: themes.primary,
                maxHeight: calculateInnerWidth ? 380 : 690,
                ml: 1,
                mr: 1,
              }}
            >
              <Mui.Table>
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow>
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                        position: "sticky",
                        left: 0,
                        backgroundColor: themes.primary,
                        zIndex: 2,
                        maxWidth: 180,
                        minWidth: 180,
                      }}
                    >
                      Employee Name
                    </Mui.TableCell>
                    {listOfDate?.map((value) => (
                      <Mui.TableCell sx={{ maxWidth: 180, minWidth: 180 }}>
                        <Mui.Stack
                          direction="column"
                          sx={{
                            alignItems: "center",
                          }}
                        >
                          <Mui.Typography
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                              fontSize: 24,
                            }}
                          >
                            {moment(value, "YYYY-MM-DD").format("DD")}
                          </Mui.Typography>
                          <Mui.Typography
                            sx={{
                              color: themes.headLine,
                              fontWeight: "bold",
                              fontSize: 12,
                            }}
                          >
                            {moment(value, "YYYY-MM-DD").format("ddd")}
                          </Mui.Typography>
                        </Mui.Stack>
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {sortedMonthlyShiftList?.length === 0 ? (
                    <InfoMessage dataLength={masterDataForSearch} />
                  ) : (
                    sortedMonthlyShiftList
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((shiftList, index) => (
                        <React.Fragment>
                          <Mui.TableRow sx={{ cursor: "pointer" }}>
                            <Mui.TableCell
                              sx={{
                                position: "sticky",
                                left: 0,
                                backgroundColor: themes.primary,
                                zIndex: 1,
                                maxWidth: 150,
                                minWidth: 130,
                              }}
                            >
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={shiftList?.user_name
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={shiftList?.image_url ?? optionalAvathar}
                                />
                                {shiftList.user_name?.length > 10 ? (
                                  <Mui.Tooltip
                                    title={shiftList.user_name}
                                    arrow
                                    slotProps={tooltipStyleProps}
                                  >
                                    <Mui.Typography
                                      sx={{
                                        paddingLeft: 1,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: 120,
                                      }}
                                    >
                                      {shiftList.user_name}
                                    </Mui.Typography>
                                  </Mui.Tooltip>
                                ) : (
                                  <Mui.Typography sx={{ paddingLeft: 1 }}>
                                    {shiftList.user_name}
                                  </Mui.Typography>
                                )}
                              </Mui.Stack>
                            </Mui.TableCell>
                            {shiftList?.shifts.map((shift, i) => (
                              <Mui.TableCell
                                sx={{
                                  fontSize: 13,
                                  border: 1,
                                  borderColor: themes.primary,
                                  backgroundColor: shift?.color_code,
                                  textAlign: "center",
                                  maxWidth: 150,
                                  minWidth: 130,
                                }}
                                onClick={() => {
                                  if (
                                    checkEditorPermission(
                                      userScreenAccess?.module_details,
                                      "Shift",
                                      "Shift"
                                    )
                                  ) {
                                    setgetSftDate(shift?.date);
                                    setUserShiftsDet(shiftList);
                                    setCurShiftDetail(shift);
                                    setLatestPayDate(
                                      shiftList?.latest_pay_date
                                    );
                                    setShiftName(
                                      shift?.shift_name === "Unassigned"
                                        ? ""
                                        : shift?.shift_name
                                    );
                                    setGetDepartmentId(
                                      shiftList?.department_id
                                    );
                                    setShiftId(shift?.shift_id);
                                    setOpenDialog(true);
                                    setTriggerApi(true);
                                  } else {
                                    showToast(
                                      "error",
                                      "Access denied: You are not authorized to change shift"
                                    );
                                  }
                                }}
                              >
                                <Mui.Stack direction="column" width={"100%"}>
                                  <Mui.Typography
                                    sx={{
                                      fontSize: 12,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {shift?.shift_name
                                      ? shift?.shift_name
                                      : "Not Joined"}
                                  </Mui.Typography>
                                  {shift?.shift_name === null ||
                                  shift?.shift_name === "Weekoff" ? (
                                    ""
                                  ) : shift?.shift_start_time &&
                                    shift?.shift_end_time ? (
                                    <>
                                      <Mui.Typography sx={{ fontSize: 10 }}>
                                        {moment(
                                          shift?.shift_start_time,
                                          "HH:mm:SS"
                                        ).format("h:mm a")}
                                        {" to "}{" "}
                                        {moment(
                                          shift?.shift_end_time,
                                          "HH:mm:SS"
                                        ).format("h:mm a")}
                                      </Mui.Typography>
                                    </>
                                  ) : null}
                                </Mui.Stack>
                              </Mui.TableCell>
                            ))}
                          </Mui.TableRow>
                        </React.Fragment>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
          </Mui.Grid>
          {sortedMonthlyShiftList.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={sortedMonthlyShiftList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
          {openDialog ? (
            <div>
              <GlobalDialogBox
                handleCloseDialog={() => {
                  setOpenDialog(false);
                  setDisable(true);
                  setGrpNameError(false);
                  setShiftBased(
                    departmentNames === "All"
                      ? "All Department"
                      : "Current Department"
                  );
                  const startDate = moment(listOfDate[0]);
                  const endDate = moment(listOfDate[listOfDate.length - 1]);
                  setState({ start: startDate, end: endDate });
                  setSelectedDates(listOfDate);
                }}
                open={openDialog}
                minWidth={800}
                title="Edit Shift Details"
              >
                <Mui.Grid container>
                  <Mui.Grid item xs={5.5}>
                    <Mui.Typography sx={formKeyText}>
                      Employee Name &nbsp;{" "}
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Displays the name of the employee whose shift details are being modified."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Mui.Typography
                      sx={{ fontWeight: 700, fontSize: 18, mt: 1.7 }}
                    >
                      {userShiftsDet?.user_name}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ mt: 1.5 }}>
                  <Mui.Grid item xs={5.5}>
                    <Mui.Typography sx={formKeyText}>
                      Date&nbsp;{" "}
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Define a full month range to update shifts throughout the selected month."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid item xs={6} sx={{ mt: 0.6 }}>
                    <DateRangePicker
                      initialSettings={{
                        startDate: start.toDate(),
                        endDate: end.toDate(),
                        applyClass: "custom-apply-btn",
                        cancelClass: "custom-cancel-btn",
                        minDate: latestPayDate
                          ? moment(latestPayDate, "DD-MM-YYYY")
                              .add(1, "day")
                              .toDate()
                          : false,
                        locale: {
                          format: "DD/MM/YYYY",
                        },
                        // isInvalidDate: (date) => {
                        //   const formatted = date.format("YYYY-MM-DD");
                        //   return !selectedDates.includes(formatted);
                        // },
                      }}
                      onCallback={handleCallback}
                    >
                      <Mui.TextField
                        id="reportrange"
                        variant="outlined"
                        label=""
                        placeholder="Select a date range"
                        value={label}
                        size="small"
                        InputProps={{
                          readOnly: true,
                          notched: false,
                          endAdornment: (
                            <Mui.InputAdornment position="end">
                              <Mui.IconButton>
                                <DateRangeIcon />
                              </Mui.IconButton>
                            </Mui.InputAdornment>
                          ),
                        }}
                        InputLabelProps={{ shrink: true, required: true }}
                        fullWidth
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            legend: {
                              display: "none",
                            },
                          },
                        }}
                      />
                    </DateRangePicker>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ mt: 1.5 }}>
                  <Mui.Grid item xs={5.5}>
                    <Mui.Typography sx={formKeyText}>
                      {" "}
                      Shift based on &nbsp;{" "}
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Choose whether to view shift options based on the employee’s current department or across all departments."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={6} container sx={{ mt: 0.5 }}>
                    <Mui.RadioGroup
                      row
                      onChange={selectShiftBased}
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue={shiftBased}
                      name="radio-buttons-group"
                    >
                      <Mui.FormControlLabel
                        label="Current Department"
                        value="Current Department"
                        control={<Mui.Radio />}
                      />

                      <Mui.FormControlLabel
                        label="All Department"
                        value="All Department"
                        control={<Mui.Radio />}
                      />
                    </Mui.RadioGroup>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid container sx={{ mt: 1.5 }}>
                  <Mui.Grid item xs={5.5}>
                    <Mui.Typography sx={formKeyText}>
                      Shift Name&nbsp;{" "}
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Select the appropriate shift to assign for the chosen date."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid item xs={6} sx={{ mt: 0.5 }}>
                    <CustomAutoComplete
                      dataList={shiftData
                        ?.filter((obj) => obj?.shift_name !== shiftName)
                        .map((obj) => ({
                          ...obj,
                          label: obj?.shift_name,
                        }))}
                      selectedValue={shiftName}
                      updateDataFunction={handleChangeShift}
                      placeHolder="Select shift group name"
                    />
                    {shiftGrpError ? (
                      <h6
                        style={{
                          paddingTop: 2,
                          color: themes.helperTextColor,
                          fontSize: 12,
                        }}
                      >
                        Shift name is required
                      </h6>
                    ) : null}
                  </Mui.Grid>
                </Mui.Grid>

                <Mui.Grid container sx={{ mt: 1 }}>
                  <Mui.Grid xs={8.9}></Mui.Grid>
                  <Mui.Grid xs={3}>
                    <CustomButton
                      actionFuntion={() => {
                        setOpenDialog(false);
                        setGrpNameError(false);
                        setDisable(true);
                        setShiftBased(
                          departmentNames === "All"
                            ? "All Department"
                            : "Current Department"
                        );
                        const startDate = moment(listOfDate[0]);
                        const endDate = moment(
                          listOfDate[listOfDate.length - 1]
                        );
                        setState({ start: startDate, end: endDate });
                        setSelectedDates(listOfDate);
                      }}
                      actionName="Cancel"
                      typeName="button"
                    />
                    &nbsp;
                    <CustomButtonWithOutLoader
                      actionName="Update"
                      typeName="submit"
                      actionFuntion={updateIndividualShift}
                      disableAction={disable}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              </GlobalDialogBox>
            </div>
          ) : null}
        </>
      )}
    </React.Fragment>
  );
};
